import type { Skill } from '@/lib/api/skills.js';

/**
 * The sentence shown beside a Fork control that is off because the skill's forks are locked. It
 * names the author only on a workspace skill that has one; a company skill never names anyone.
 */
export function forkLockCaption(
  skill: Pick<Skill, 'scope' | 'fork_lock_author_name'>,
): string {
  const base = 'Forking is turned off for this skill.';
  if (skill.scope === 'corporate' || !skill.fork_lock_author_name) return base;
  return `${base} Contact the author, ${skill.fork_lock_author_name}.`;
}
